<!--
  - Copyright Huesik (c) 2019.
  -->

<template>
<div>
    <header v-if="!isiOSNative" class="new-header-tab">
        <div class="logo-wrapper" v-if="$mq !== 'sm'">
            <logo></logo>
        </div>
        <div class="management-wrapper not-show-sm">
            <p>
                <span class="download-btn" style="margin-left: 10px;">
                    <a :href="kosirockPromotion.link" target="_blank">
                        {{kosirockPromotion.title}}
                    </a>
                </span>
            </p>
        </div>
        <div class="menu-item-wrapper">
            <ul>
                <main-menu-header-item v-for="(menuItem, index) in menuList.MAIN" :href="menuItem.HREF" :name="menuItem.NAME" :classes="menuItem.CLASS" :target="menuItem.TARGET" :show-login="menuItem.SHOW_LOGIN" :key="`__MENU__${index}`" />
            </ul>
        </div>
    </header>
    <nav class="mobile-tab new-mobile-tab">
        <ul class="flex-s--c wh-100">
            <!-- /class="" -->
            <li :class="{is_active : 'home' === currentRouteName}">
                <a @click="goTomenu('/')">
                    <figure>
                        <svg width="30" height="28" viewBox="0 0 30 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24 22C24 22.2652 23.8946 22.5196 23.7071 22.7071C23.5196 22.8947 23.2652 23 23 23H7C6.73478 23 6.48043 22.8947 6.29289 22.7071C6.10536 22.5196 6 22.2652 6 22V11.49C5.99989 11.3376 6.03462 11.1872 6.10152 11.0503C6.16841 10.9134 6.26572 10.7936 6.386 10.7L14.386 4.47803C14.5615 4.34147 14.7776 4.26733 15 4.26733C15.2224 4.26733 15.4385 4.34147 15.614 4.47803L23.614 10.7C23.7343 10.7936 23.8316 10.9134 23.8985 11.0503C23.9654 11.1872 24.0001 11.3376 24 11.49V22ZM22 21V12.9562C22 12.339 21.715 11.7564 21.2278 11.3775L16.2278 7.48892C15.5056 6.92726 14.4944 6.92726 13.7722 7.48892L8.77218 11.3775C8.28497 11.7564 8 12.339 8 12.9562V21H22Z" fill="#888" />
                        </svg>
                    </figure>
                    <span class="font-engNum">home</span>
                </a>
            </li>
            <li :class="{is_active : 'search' === currentRouteName}">
                <a @click="goTomenu('/search?latitude=37.5546788388674&longitude=126.970606917394')">
                    <figure>
                        <svg width="30" height="28" viewBox="0 0 30 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15 15C16.6569 15 18 13.6569 18 12C18 10.3431 16.6569 9 15 9C13.3431 9 12 10.3431 12 12C12 13.6569 13.3431 15 15 15Z" stroke="#888888" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M15 4C12.8783 4 10.8434 4.84285 9.34315 6.34315C7.84285 7.84344 7 9.87827 7 12C7 13.892 7.402 15.13 8.5 16.5L15 24L21.5 16.5C22.598 15.13 23 13.892 23 12C23 9.87827 22.1571 7.84344 20.6569 6.34315C19.1566 4.84285 17.1217 4 15 4V4Z" stroke="#888888" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </figure>
                    <span>지도로 찾기</span>
                </a>
            </li>
            <li :class="{is_active : 'interest' === currentRouteName}">
                <a @click="goTomenu('/interest')">
                    <figure>
                        <svg width="30" height="28" viewBox="0 0 30 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15 23C14.355 22.428 13.626 21.833 12.855 21.2H12.845C10.13 18.98 7.05301 16.468 5.69401 13.458C5.24801 12.5 5.01101 11.458 5.00001 10.4C4.99853 9.68201 5.14052 8.97093 5.41765 8.30855C5.69478 7.64616 6.10147 7.04583 6.61382 6.54279C7.12617 6.03975 7.73387 5.64416 8.40122 5.37922C9.06858 5.11429 9.78214 4.98537 10.5 5.00002C11.6806 5.00189 12.8358 5.34311 13.828 5.98302C14.264 6.26599 14.6584 6.60828 15 7.00002C15.344 6.61002 15.738 6.26802 16.173 5.98302C17.1647 5.34298 18.3197 5.00174 19.5 5.00002C20.2179 4.98537 20.9314 5.11429 21.5988 5.37922C22.2662 5.64416 22.8739 6.03975 23.3862 6.54279C23.8986 7.04583 24.3052 7.64616 24.5824 8.30855C24.8595 8.97093 25.0015 9.68201 25 10.4C24.9898 11.4588 24.7532 12.5032 24.306 13.463C22.947 16.473 19.871 18.984 17.156 21.2L17.146 21.208C16.374 21.837 15.646 22.432 15.001 23.008L15 23ZM10.5 7.00002C9.56852 6.98837 8.67008 7.34487 8.00001 7.99202C7.68047 8.3059 7.42728 8.68081 7.25549 9.09448C7.0837 9.50814 6.99682 9.95212 7.00001 10.4C7.01101 11.17 7.18601 11.93 7.51201 12.628C8.15354 13.9267 9.01914 15.1021 10.069 16.1C11.06 17.1 12.2 18.068 13.186 18.882C13.459 19.107 13.737 19.334 14.015 19.561L14.19 19.704C14.457 19.922 14.733 20.148 15 20.37L15.013 20.358L15.019 20.353H15.025L15.034 20.346H15.044L15.062 20.331L15.103 20.298L15.11 20.292L15.121 20.284H15.127L15.136 20.276L15.8 19.731L15.974 19.588C16.255 19.359 16.533 19.132 16.806 18.907C17.792 18.093 18.933 17.126 19.924 16.121C20.9741 15.1236 21.8397 13.9486 22.481 12.65C22.813 11.946 22.991 11.178 23.001 10.4C23.0029 9.9534 22.9154 9.51092 22.7434 9.09871C22.5715 8.6865 22.3187 8.31291 22 8.00002C21.3312 7.34994 20.4326 6.99051 19.5 7.00002C18.9373 6.99524 18.38 7.10958 17.8647 7.33554C17.3494 7.56149 16.8877 7.89393 16.51 8.31102L15 10.051L13.49 8.31102C13.1123 7.89393 12.6506 7.56149 12.1353 7.33554C11.62 7.10958 11.0627 6.99524 10.5 7.00002Z" fill="#888888" />
                        </svg>
                    </figure>
                    <span>관심</span>
                </a>
            </li>
            <li :class="{is_active : 'more' === currentRouteName}">
                <a @click="goTomenu('/more')">
                    <figure>
                        <svg width="30" height="28" viewBox="0 0 30 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.7143 15.4286C11.0932 15.4286 11.4565 15.2781 11.7244 15.0102C11.9923 14.7422 12.1429 14.3789 12.1429 14C12.1429 13.6211 11.9923 13.2578 11.7244 12.9898C11.4565 12.7219 11.0932 12.5714 10.7143 12.5714C10.3354 12.5714 9.97204 12.7219 9.70413 12.9898C9.43622 13.2578 9.28571 13.6211 9.28571 14C9.28571 14.3789 9.43622 14.7422 9.70413 15.0102C9.97204 15.2781 10.3354 15.4286 10.7143 15.4286ZM15 15.4286C15.3789 15.4286 15.7422 15.2781 16.0102 15.0102C16.2781 14.7422 16.4286 14.3789 16.4286 14C16.4286 13.6211 16.2781 13.2578 16.0102 12.9898C15.7422 12.7219 15.3789 12.5714 15 12.5714C14.6211 12.5714 14.2578 12.7219 13.9898 12.9898C13.7219 13.2578 13.5714 13.6211 13.5714 14C13.5714 14.3789 13.7219 14.7422 13.9898 15.0102C14.2578 15.2781 14.6211 15.4286 15 15.4286ZM20.7143 14C20.7143 14.3789 20.5638 14.7422 20.2959 15.0102C20.028 15.2781 19.6646 15.4286 19.2857 15.4286C18.9068 15.4286 18.5435 15.2781 18.2756 15.0102C18.0077 14.7422 17.8571 14.3789 17.8571 14C17.8571 13.6211 18.0077 13.2578 18.2756 12.9898C18.5435 12.7219 18.9068 12.5714 19.2857 12.5714C19.6646 12.5714 20.028 12.7219 20.2959 12.9898C20.5638 13.2578 20.7143 13.6211 20.7143 14ZM25 14C25 19.5229 20.5229 24 15 24C9.47714 24 5 19.5229 5 14C5 8.47714 9.47714 4 15 4C20.5229 4 25 8.47714 25 14ZM23.5714 14C23.5714 9.26643 19.7336 5.42857 15 5.42857C10.2664 5.42857 6.42857 9.26643 6.42857 14C6.42857 18.7336 10.2664 22.5714 15 22.5714C19.7336 22.5714 23.5714 18.7336 23.5714 14Z" fill="#888888" />
                        </svg>
                    </figure>
                    <span>더보기</span>
                </a>
            </li>
        </ul>
    </nav>
</div>
</template>

<script>
import {
    CONSTANTS
} from '../../const'
import MainMenuHeaderItem from './MainMenuHeaderItem'
import Logo from '../Commons/Logo'

export default {
    name: 'MainMenuHeader',
    components: {
        MainMenuHeaderItem,
        Logo
    },
    data() {
        return {
            kosirockPromotion: {
                title: "고시락 홍보 방법",
                link: "https://s3.ap-northeast-2.amazonaws.com/huesik.static/kosirock_new_information_250611.pdf"
            },
            menuList: CONSTANTS.MENU,
            currentRouteName: this.$route.name
        }
    },
    computed: {
        isiOS() {
            return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
        },
        isiOSNative() {
            return this.$store.state.APP.IS_NATIVE && this.isiOS
        }
    },
    mounted() {

        // console.log(this.currentRouteName);

    },
    methods: {
        goTomenu(link) {
            this.$router.push(link);
        }
    }
}
</script>

<style lang="less" scoped>
@import "../../assets/css/palette";

.new-mobile-tab {
    display: none;
}

header {
    display: flex;
    height: 8rem;
    line-height: 8rem;
    padding: 0 6.4rem;
    border-bottom: 2px solid @windows-blue-two;
    box-sizing: border-box;
    background: @white;

    .logo-wrapper {
        padding: 0 1rem 0 0;
        flex: initial;
    }

    .management-wrapper {
        padding: 0 1rem;
        flex: initial;

        p {
            height: 100%;
            line-height: 100%;
            /* text-align: left; */
            /* vertical-align: middle; */
            display: flex;
            flex-direction: column;
            justify-content: center;

            .upper {
                color: #FDae2a;
                font-size: 0.6rem;
                text-align: left;
            }
        }
    }

    .menu-item-wrapper {
        justify-content: flex-end;
        flex: auto;

        ul {
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-end;
            flex: 1;
        }
    }
}
</style>

<style lang="less" scoped>
/* Medium devices (landscape tablets, 768px and up) */
@media screen and (max-width: 768px) {
    .new-header-tab {
        display: none;
    }

    .new-mobile-tab {
        display: block;
    }

    // header {
    //   width: 100%;
    //   position: fixed;
    //   bottom: 0;
    //   border-bottom: 0;
    //   border-top: 1px solid #dddddd;
    //   padding: 0;
    //   z-index: 2;
    //   height: 6.25rem;
    //   line-height: 4.25rem;
    //   transform: translateY(0);

    //   .menu-item-wrapper {
    //     justify-content: space-between;
    //     flex: auto;

    //     ul {
    //       display: flex;
    //       flex-wrap: wrap;
    //       justify-content: space-between;
    //       flex: 1;
    //       height: 100%;
    //       padding-top: 1rem;
    //     }
    //   }
    // }
}
</style>
